export const MAX_UPLOAD_SIZE = 10 * 1024 * 1024;
export const MAX_PICTURE_WIDTH = 1920;
export const MAX_PICTURE_HEIGHT = 1080;

/**
 * Image permission: Read Write Execute
 * @type {number}
 */
export const IMAGE_PERMISSION_RWE = 7;

/**
 * Image permission: Read only
 * @type {number}
 */
export const IMAGE_PERMISSION_R = 4;
